'use client';
import * as Styled from './styled';
import * as Icon from '@/ui/Icon';
import { RenderHeaderCellProps } from 'react-data-grid';
import { ColumnWithDType } from '../../types';
import { TRenderAsEnum } from '../../DataGrid/lib';

const iconSize = '12';
const statusIcons = {
  added: <Icon.Add size={iconSize} />,
  removed: <Icon.Minus size={iconSize} />,
  deleted: <Icon.Minus size={iconSize} />,
  modified: <Icon.Triangle size={iconSize} />,
  unchanged: <Icon.EyeOpen size={iconSize} />,
  dirty: <Icon.Triangle size={iconSize} />,
};

type TDiffStatusEnum = 'added' | 'removed' | 'deleted' | 'modified' | 'unchanged' | 'dirty';

export const Cell: React.FC<
  React.HTMLAttributes<HTMLDivElement> & { field: ColumnWithDType; value: string; renderAs?: TRenderAsEnum }
> = ({ field, value, renderAs, ...rest }) => {
  const statusIndicator = statusIcons[value as TDiffStatusEnum];
  return (
    <Styled.Cell {...rest}>
      <Styled.StatusIndicator className={value}>{statusIndicator}</Styled.StatusIndicator>
    </Styled.Cell>
  );
};

export const Header: React.FC<RenderHeaderCellProps<any> & { children: React.ReactNode }> = ({ children, ...rest }) => {
  return <div />;
};

export const Details: React.FC<{}> = ({}) => {
  return null;
};
